import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  addNewCandidate,
  adminUserAPI,
  uploadHistoryAPI,
  uploadTrackerAPI,
} from "../../api/candidate";
import { ThreeDots } from "react-loader-spinner"; // Importing a loading spinner library
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { downloadCSV } from "../../../helpers/dataTableHelper";

const initialState = {
  excelfile: "",
  resumes: [],
};

const AddCandidate = () => {
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [responses, setResponses] = useState(null);

  const [tdata, setTdata] = useState([]);
  const [tloading, setTloading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
  });
  const [fetch, setFetch] = useState(true);

  const [trdata, setTrdata] = useState([]);
  const [trloading, setTrloading] = useState(false);
  //const [trTotalRows, setTrTotalRows] = useState(0);
  const [trPerPage, setTrPerPage] = useState(10);
  const [trCurrentPage, setTrCurrentPage] = useState(1);
  const [trReqParams, setTrReqParams] = useState({
    page: trCurrentPage,
    limit: trPerPage,
    sort_by: "created_by",
    sort_direction: "DESC",
    from_date: "",
    to_date: "",
    created_by: "",
  });
  const [trFetch, setTrFetch] = useState(true);
  const [userList, setUserList] = useState([]);

  //const navigate = useNavigate();
  const roleName = useSelector((state) => state.auth?.auth?.roleName);

  const handleFileChange = (e) => {
    const files = e.target.files;
    const name = e.target.name;
    if (name === "excelfile") {
      if (
        files[0].type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        swal("Invalid file type", "Please upload an .xlsx file", "error");
        return;
      }
      setData((prevState) => ({
        ...prevState,
        excelfile: files[0],
      }));
    } else if (name === "resumes") {
      let valid = true;
      for (let i = 0; i < files.length; i++) {
        if (
          (files[i].type !== "application/pdf" &&
            files[i].type !== "application/msword" &&
            files[i].type !==
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
          files[i].size > 6000 * 6000
        ) {
          valid = false;
          break;
        }
      }
      if (!valid) {
        swal(
          "Invalid file type or size",
          "Please upload PDFs not exceeding 5 MB each",
          "error"
        );
        return;
      }
      setData((prevState) => ({
        ...prevState,
        resumes: files,
      }));
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    for (const key in data) {
      if (key === "resumes") {
        for (let i = 0; i < data[key].length; i++) {
          formData.append("resumes", data[key][i]);
        }
      } else {
        formData.append(key, data[key]);
      }
    }

    try {
      let res = await addNewCandidate(formData);
      if (res?.data) {
        setResponses({
          account_created: res.data.account_created || [],
          already_exists: res.data.already_exists || [],
          invalid_email: res.data.invalid_email || [],
          response_error: res.data.response_error || [],
          updated_users: res.data.updated_users || [],
          not_found: res.data.not_found || [],
        });
      }
    } catch (error) {
      swal("Error", error?.response.data.error, "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchUploadTracker = useCallback(
    (params) => {
      setTrloading(true);
      uploadTrackerAPI(params)
        .then((res) => {
          setTrdata(res?.data?.data);
          //setTrTotalRows(res?.data?.total);
          setTrloading(false);
          setTrFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setTrloading(false);
          setTrFetch(false);
        });
    },
    [setTrFetch]
  );

  const fetchUsers = useCallback(
    (params) => {
      setTloading(true);
      uploadHistoryAPI(params)
        .then((res) => {
          setTdata(res?.data?.data);
          setTotalRows(res?.data?.total);
          setTloading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setTloading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  const fetchAadminUser = useCallback(() => {
    setTloading(true);
    adminUserAPI()
      .then((res) => {
        setUserList(res?.data?.data);
      })
      .catch((err) => {
        swal("Error", err?.message, "error");
      });
  }, []);

  useEffect(() => {
    fetchAadminUser();
  }, [fetchAadminUser]);

  useEffect(() => {
    if (fetch && roleName === "Super Admin") {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, roleName, fetchUsers]);

  useEffect(() => {
    if (trFetch && roleName === "Super Admin") {
      fetchUploadTracker(trReqParams);
    }
  }, [trFetch, trReqParams, roleName, fetchUploadTracker]);

  const columns = useMemo(
    () => [
      {
        name: "Id",
        selector: (row) => row.id,
        wrap: true,
        width: "80px",
        sortable: true,
        sortField: "id",
      },
      {
        name: "File Name",
        selector: (row) =>
          row.file_url ? (
            <a href={row.file_url} className="text-warning" target="_blank">
              {row.file_name}
            </a>
          ) : (
            row.file_name
          ),
        wrap: true,
        sortable: true,
        sortField: "file_name",
      },
      {
        name: "Account Created",
        selector: (row) => row.account_created_count,
        wrap: true,
        sortable: true,
        sortField: "account_created_count",
      },
      {
        name: "Already Exists",
        selector: (row) => row.already_exists_count,
        wrap: true,
        sortable: true,
        sortField: "already_exists_count",
      },
      {
        name: "Invalid Emails",
        selector: (row) => row.invalid_email_count,
        wrap: true,
        sortable: true,
        sortField: "invalid_email_count",
      },
      {
        name: "Response Error",
        selector: (row) => row.response_error_count,
        wrap: true,
        sortable: true,
        sortField: "response_error_count",
      },
      {
        name: "Uploaded By",
        selector: (row) => row.created_by,
        sortable: false,
        wrap: true,
        sortField: "created_by",
      },
      {
        name: "Uploaded At",
        selector: (row) => row.updated_at,
        wrap: true,
        sortable: true,
        sortField: "updated_at",
      },
    ],
    []
  );

  const trColumns = useMemo(
    () => [
      {
        name: "Total Uploads",
        selector: (row) => row.total_file_uploads,
        wrap: true,
        width: "140px",
        sortable: true,
        sortField: "total_file_uploads",
      },
      {
        name: "File Type",
        width: "110px",
        selector: (row) => row.file_type,
        wrap: true,
        sortable: true,
        sortField: "file_type",
      },
      {
        name: "Total Records",
        selector: (row) => row.total_records,
        wrap: true,
        width: "135px",
        sortable: true,
        sortField: "total_records",
      },
      {
        name: "New Accounts",
        selector: (row) => row.total_account_created_count,
        wrap: true,
        width: "135px",
        sortable: true,
        sortField: "total_account_created_count",
      },
      {
        name: "Existing Accounts",
        selector: (row) => row.total_already_exists_count,
        wrap: true,
        width: "155px",
        sortable: true,
        sortField: "total_already_exists_count",
      },
      {
        name: "Invalid/Response Error",
        selector: (row) =>
          row.total_response_error_count + row.total_invalid_email_count,
        wrap: true,
        sortable: true,
        sortField: "total_response_error_count",
      },
      {
        name: "Uploaded by",
        selector: (row) => row.created_by,
        wrap: true,
        sortable: true,
        sortField: "created_by",
      },
    ],
    []
  );

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const trHandlePageChange = useCallback(
    (page) => {
      setTrCurrentPage(page);
      setTrReqParams({
        ...trReqParams,
        page: page,
      });
      setTrFetch(true);
    },
    [setTrReqParams, trReqParams, setTrFetch]
  );

  const trHandlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setTrPerPage(newPerPage);
      setTrReqParams({
        ...trReqParams,
        limit: newPerPage,
      });
      setTrFetch(true);
    },
    [setTrReqParams, trReqParams, setTrFetch]
  );

  const trHandleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setTrReqParams({
          ...trReqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setTrFetch(true);
      }
    },
    [trReqParams, setTrReqParams, setTrFetch]
  );

  const onClear = useCallback(() => {
    setTrReqParams({
      ...trReqParams,
      page: 1,
      from_date: "",
      to_date: "",
      created_by: "",
    });
    setTrFetch(true);
  }, [trReqParams, setTrReqParams, setTrFetch]);

  return (
    <>
      <div className="container mt-5">
        <div className="d-flex align-items-center mb-4 flex-wrap">
          <h4 className="fs-20 font-w600 me-auto">Upload Candidates</h4>
          <Link to="/c_lists" className="btn btn-primary me-3 btn-sm">
            <i className="fas fa-plus me-2"></i>Back to Listing
          </Link>
        </div>

        {!responses && (
          <>
            <div className="row">
              <div className="col-xl-12 col-xxl-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Attachment</h4>
                  </div>
                  <div className="card-body">
                    <p className="text-muted">
                      Please upload an .xlsx file for Excel and PDF files for
                      resumes. Each PDF should not exceed 1 MB.
                    </p>
                    <div className="mb-3">
                      <label className="form-label">Excel File</label>
                      <input
                        type="file"
                        name="excelfile"
                        className="form-control"
                        onChange={handleFileChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Resumes</label>
                      <input
                        type="file"
                        name="resumes"
                        className="form-control"
                        multiple
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <ThreeDots
                      visible={true}
                      height="80"
                      width="80"
                      color="#4fa94d"
                      radius="9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />{" "}
                    Uploading...
                  </>
                ) : (
                  "Upload Candidates"
                )}
              </button>
            </div>
          </>
        )}
        {responses && (
          <div className="row mt-3">
            <div className="col-xl-12 col-xxl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">
                    Result Response - Account Created:{" "}
                    {responses.account_created.length}, Already Exists:{" "}
                    {responses.already_exists.length}, Invalid Email:{" "}
                    {responses.invalid_email.length}, Response Error :{" "}
                    {responses?.response_error?.length}
                  </h4>
                </div>
                <div className="card-body">
                  <p>
                    <strong>Account Created:</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: responses.account_created.join("<br/>"),
                      }}
                    ></div>
                  </p>
                  <p>
                    <strong>Already Exists:</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: responses.already_exists.join("<br/>"),
                      }}
                    ></div>
                  </p>
                  <p>
                    <strong>Invalid Email:</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: responses.invalid_email.join("<br/>"),
                      }}
                    ></div>
                  </p>
                  <p>
                    <strong>Response Error:</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: responses.response_error.join("<br/>"),
                      }}
                    ></div>
                  </p>
                  <p>
                    <strong>Resume Account Not Found:</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: responses.not_found.join("<br/>"),
                      }}
                    ></div>
                  </p>
                  <p>
                    <strong>Uploaded Resumes:</strong>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: responses.updated_users.join("<br/>"),
                      }}
                    ></div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {roleName === "Super Admin" ? (
        <>
          <div className="container mt-5">
            <div className="row mb-4">
              <div className="col-md-2 pe-0">
                <br />
                <h4 className="fs-20 font-w600 me-auto">Upload Tracker</h4>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="text-black font-w500">From date</label>
                      <input
                        type="date"
                        className="form-control"
                        autoComplete="off"
                        name="from_date"
                        defaultValue={trReqParams.from_date || ""}
                        value={trReqParams.from_date}
                        onChange={(e) => {
                          setTrReqParams({
                            ...trReqParams,
                            from_date: e.target.value,
                          });
                          setTrFetch(true);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="text-black font-w500">To date</label>
                      <input
                        type="date"
                        className="form-control"
                        autoComplete="off"
                        name="to_date"
                        defaultValue={trReqParams.to_date || ""}
                        //onChange={handleEditFormChange}
                        value={trReqParams.to_date}
                        onChange={(e) => {
                          setTrReqParams({
                            ...trReqParams,
                            to_date: e.target.value,
                          });
                          setTrFetch(true);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="text-black font-w500">
                        Select User
                      </label>
                      <select
                        className="form-select"
                        defaultValue={trReqParams.created_by || ""}
                        value={trReqParams.created_by}
                        onChange={(e) => {
                          setTrReqParams({
                            ...trReqParams,
                            created_by: e.target.value,
                          });
                          setTrFetch(true);
                        }}
                      >
                        <option value="">Select user</option>
                        {userList.map((user, i) => (
                          <option value={user.name} key={i}>
                            {user.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <br />
                    <button
                      onClick={() => onClear()}
                      className="btn btn-primary btn-sm mt-2"
                    >
                      <i className="fas fa-times me-1"></i>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <br />
                    <button
                      onClick={() => downloadCSV(trdata, "upload-tracker-")}
                      className="btn btn-warning btn-sm mt-2"
                    >
                      <i className="fas fa-file-csv me-1"></i> Export
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="table-responsive">
                  <DataTable
                    columns={trColumns}
                    data={trdata}
                    progressPending={trloading}
                    pagination
                    paginationServer
                    //paginationTotalRows={trTotalRows}
                    //paginationDefaultPage={trCurrentPage}
                    onChangeRowsPerPage={trHandlePerRowsChange}
                    onChangePage={trHandlePageChange}
                    //selectableRows
                    persistTableHead
                    //clearSelectedRows={toggleCleared}
                    //conditionalRowStyles={rowStyle}
                    //   onSelectedRowsChange={({ selectedRows }) => {
                    //     //console.log(selectedRows)
                    //     setSelectedRows(selectedRows);
                    //   }}
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                    onSort={trHandleSort}
                    sortServer
                    fixedHeader={true}
                    fixedHeaderScrollHeight={"500px"}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container mt-5">
            <div className="d-flex align-items-center mb-4 flex-wrap">
              <h4 className="fs-20 font-w600 me-auto">Upload History</h4>
              <button
                onClick={() => downloadCSV(tdata, "upload-history-")}
                className="btn btn-warning btn-sm me-2"
              >
                <i className="fas fa-file-csv me-1"></i> Export
              </button>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={tdata}
                    progressPending={tloading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                    //selectableRows
                    persistTableHead
                    //clearSelectedRows={toggleCleared}
                    //conditionalRowStyles={rowStyle}
                    //   onSelectedRowsChange={({ selectedRows }) => {
                    //     //console.log(selectedRows)
                    //     setSelectedRows(selectedRows);
                    //   }}
                    onSort={handleSort}
                    sortServer
                    fixedHeader={true}
                    fixedHeaderScrollHeight={"500px"}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default AddCandidate;
